import * as i18n from "util/i18n";
import { getTransferExecuteLabels as getShellLabels } from "v3/v3UiKitI18n";
import { transfersTestIds } from "@ui-kit/components/index.es";

/**
 * Labels for transfer execute ui-kit forms (internal / thirdParties / toContact).
 *
 * @param {"internal"|"thirdParties"|"toContact"} formType
 * @returns {(id: string) => string}
 */
export function createTransferExecuteFormLabels(formType) {
    const formPrefixByType = {
        internal: "transferInternal",
        thirdParties: "transferThirdParties",
        toContact: "transferToContact",
    };
    const formPrefix = formPrefixByType[formType] || "transferToContact";

    return (id) => {
        const map = {
            pageTitle: i18n.get("transfers.make.transfer.title"),
            debitAccount: i18n.get("transfers.form.debit.account"),
            debitAccountPlaceholder: i18n.get("transfers.form.debit.account.placeholder", "Seleccioná"),
            creditAccount:
                formType === "internal"
                    ? i18n.get("transfers.form.credit.account")
                    : i18n.get("transfers.form.cbu.label"),
            creditAccountPlaceholder:
                formType === "internal"
                    ? i18n.get("transfers.form.credit.account.placeholder")
                    : i18n.get("transfers.form.cbu.placeholder"),
            invalidFormat: i18n.get("transfers.validation.invalidFormat"),
            amount: i18n.get("transfers.form.amount"),
            reference: i18n.get("transfers.form.reference"),
            referencePlaceholder: i18n.get("transfers.form.reference.placeholder"),
            transferKind: i18n.get("transfers.form.transfer.kind"),
            transferKindPlaceholder: i18n.get("transfers.form.select.transfer.placeholder"),
            concept: i18n.get("transfers.form.transfer.concept"),
            conceptPlaceholder: i18n.get("transfers.form.concept.placeholder"),
            sendEmail: i18n.get("transfers.form.send.mail"),
            email: i18n.get("transfers.form.email", "Email"),
            emailText: i18n.get("transfers.form.email.message", "Mensaje"),
            schedule: i18n.get("transfers.form.schedule"),
            saveDraft: i18n.get("transfers.form.save.draft"),
            saveTemplate: i18n.get("transfers.form.save.template"),
            continue: i18n.get("transfers.form.continue"),
            contactSectionTitle: i18n.get("transfers.form.contact.select"),
            recipientHolder: i18n.get("transferSummary.owner.label"),
            recipientCuil: i18n.get("transferSummary.cuit.label"),
            recipientBank: i18n.get("transferSummary.bank.label"),
            recipientInfoTitle: i18n.get("transfers.form.recipient.info", "Datos del destinatario"),
            titular: i18n.get("transferSummary.owner.label"),
            cuil: i18n.get("transferSummary.cuit.label"),
            bank: i18n.get("transferSummary.bank.label"),
        };

        if (map[id]) {
            return map[id];
        }

        const keyed = i18n.get(`${formPrefix}.${id}`, null);
        if (keyed && !String(keyed).startsWith("*")) {
            return keyed;
        }

        return getShellLabels(id);
    };
}

/** Opción de PageHeader V3 para abrir el drawer de plantillas (paridad V2Transfer desktop). */
export function buildTransferExecuteTemplatesHeaderOption(onOpenTemplates) {
    return {
        label: i18n.get("transfers.templates"),
        icon: "NewspaperAlt",
        iconVariant: "outline",
        buttonVariant: "outline",
        callback: onOpenTemplates,
        id: "open-menu",
        "data-testid": transfersTestIds.execute.templates,
    };
}

export { getTransferExecuteLabels } from "v3/v3UiKitI18n";
